import { useQuery } from '@tanstack/react-query'
import { getUsers as getUsersApi } from '../services/apiUsers.ts'

type Role = 'ROLE_MANAGER' | 'ROLE_EDITOR' | 'ROLE_VIEWER'

interface Organization {
  id: number
  name: string
  address: string
  phone: string
  email: string
}

export interface User {
  userId: string
  firstName: string
  lastName: string
  email: string
  role: Role[]
  organizations: Organization[]
}

export function useUsers() {
  const {
    isLoading,
    data: allUsers,
    error,
  } = useQuery<User[], Error>({ queryKey: ['users'], queryFn: getUsersApi })

  return { isLoading, allUsers, error }
}
